export default "__VITE_ASSET__BVHQEYEx__"